import { Button, Icon, Modal } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { TranslationsKeys } from '../../../../locales/translations';
import { useMemo } from 'react';
import { UseFormHandleSubmit } from 'react-hook-form';
import {
  StudentsRemovalPendingRequestFormSubmitKey,
  StudentsRemovalRequestsPendingFormFields,
} from '../types/removal-requests-pending';

interface Props {
  handleClose: () => void;
  isLoading: {
    resolve: boolean;
    resolveAndChangeState: boolean;
  };
  handleSubmit: UseFormHandleSubmit<StudentsRemovalRequestsPendingFormFields>;
  onSubmit: (
    key: StudentsRemovalPendingRequestFormSubmitKey,
    values: StudentsRemovalRequestsPendingFormFields,
  ) => Promise<void>;
}

export function StudentsRemovalRequestPendingSubmitDialog({
  handleClose,
  isLoading,
  handleSubmit,
  onSubmit,
}: Props) {
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST_MANAGEMENT_DETAILS,
  );

  const texts = useMemo(
    () => ({
      title: t('submitDialog.title'),
      description: t('submitDialog.description'),
      confirm: t('submitDialog.confirm'),
      changeStateAndConfirm: t('submitDialog.changeStateAndConfirm'),
      cancel: t('submitDialog.cancel'),
    }),
    [t],
  );

  return (
    <Modal isOpen size="lg" toggle={handleClose} closeOnBackdrop={!isLoading}>
      <Row className="text-center">
        <Col xs={12} className="pt-2 mb-4">
          <Icon name="information" size="52px" color="secondary" />
        </Col>
      </Row>
      <Row className="justify-content-center mb-4">
        <Col xs={12} md={10}>
          <h1 className="text-dark text-center fw-600 fs-20">{texts.title}</h1>
          <p className=" text-center fs-16 mb-4">{texts.description}</p>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={4}>
          <Button
            type="button"
            onClick={handleClose}
            text={texts.cancel}
            color="danger"
            fullwidth
            outlined
            disabled={isLoading.resolve || isLoading.resolveAndChangeState}
          />
        </Col>
        <Col xs={12} md={4}>
          <Button
            type="button"
            onClick={handleSubmit((values) =>
              onSubmit(
                StudentsRemovalPendingRequestFormSubmitKey.RESOLVE,
                values,
              ),
            )}
            text={texts.confirm}
            color="primary"
            fullwidth
            outlined
            loading={isLoading.resolve}
            disabled={isLoading.resolveAndChangeState}
          />
        </Col>
        <Col xs={12} md={4}>
          <Button
            type="button"
            onClick={handleSubmit((values) =>
              onSubmit(
                StudentsRemovalPendingRequestFormSubmitKey.RESOLVE_AND_CHANGE_STATE,
                values,
              ),
            )}
            text={texts.changeStateAndConfirm}
            color="primary"
            fullwidth
            loading={isLoading.resolveAndChangeState}
            disabled={isLoading.resolve}
          />
        </Col>
      </Row>
    </Modal>
  );
}
